import React, { useEffect, useState } from 'react';
// MUI
import { Box, Snackbar, Switch, useMediaQuery } from '@mui/material';
import CkEeditorfields from '../../../Common/CKeditor/CkEeditorfields';
import PrimaryButton from '../../../Common/Button/PrimaryButton';
// Assests/Images
import AlignIcon from '../../../../Assets/Images/svgs/textalign-left.svg';
import fieldIcon from '../../../../Assets/Images/svgs/Vector.svg';
import imageIcon from '../../../../Assets/Images/svgs/gallery.svg';
import dateIcon from '../../../../Assets/Images/svgs/calendar-2.svg';
import icon from '../../../../Assets/Images/svgs/format-square.svg';
import TableIcon from '../../../../Assets/Images/svgs/tableIcon.svg';
import PageIcon from '../../../../Assets/Images/page.svg';
import CheckboxIcon from '../../../../Assets/Images/svgs/checkbox.svg';
import LineIcon from '../../../../Assets/Images/lineIcon.svg';
import StampIcon from '../../../../Assets/Images/svgs/stamp.svg';
import DropdownIcon from '../../../../Assets/Images/dropdown.svg';
import TagUserIcon from '../../../../Assets/Images/svgs/tag-user.svg';

// API
import { fetchTemplateById, GetConfigData } from '../../../../Services/APIConfig';

import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { TextField } from '../../../Common/Textfield';

import PreviewUploadDocument from '../../../Common/PDFPreview';
import { setAutoSave, updateContent } from '../../../../Store/Redux/CKEditorSlice';
import SuccessModal from '../../../Common/Modal/SuccessModal/SuccessModal';
import {
  addAdditionalCharges,
  holdTemplateNames,
  selecteFileStatus,
  setPdfloader
} from '../../../../Store/Redux/FileListSlice';
import { mapFields } from '../../../../utils/MapInputFields';

import { useQueryParameters } from '../../../Common/useQueryParameters';
import { nanoid } from 'nanoid';

import CkRecipientDropDown from '../../../Common/CKeditor/CkRecipientDropDown';
import CKeditorSignDropDown from '../../../Common/CKeditor/CKeditorSignDropDown';
import { fillRecipientsInput, getPdfSingFeild, getSignFields } from '../../../Common/CKeditor/Fields/GetFields';
import { mapTables } from '../../../../utils/MapTables';
import { scrollstyleCss } from '../../../../Styles/Styles';
import { handleTemplateSave } from './CkConstants';
import GeneralModal from '../../../Common/Modal/GeneralModal/GeneralModal';
import CustomToast from '../../../Common/CustomToast';
import Loading from '../../../Common/LoaderComponent/Loader';

function CKeditorAddComp({ handleSidebarClick, editor, borderData, marginData, getDataOne, getDataTwo, documentID }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:768px)');
  const { showToast } = CustomToast();
  const [disableAddRecipient] = useState(false);

  const selPdf = useSelector(state => state.fileList.selPdf);
  const storedRecipients = useSelector(state => state.recipients.data.recipientsList);
  const { editorPageSize, autoSave, pageOrientation } = useSelector(state => state.ckeditor);

  const {
    attachedfiles,
    selectedFile,
    holdTemplateName,
    singedInputFields,

    recpInput,
    stampConfig,
    additionalCharges,
    isAdditionalAmountRequired
  } = useSelector(state => state.fileList);

  const [previewFile, setPreviewFile] = useState('');
  const [originalFiles, setOriginalFiles] = useState([]);
  // singed fields for pdf
  const [signinputFields, setSignInputFields] = useState([]);
  const [recipientInputFields, setRecipientInputFields] = useState([]);
  // for template
  const [templateSingedFields, setTemplateSingedFields] = useState([]);

  const [snackBar, setSnackbar] = useState(false);
  const [snackBarmsg, setSnackbarMsg] = useState(false);
  const [isPdf, setIsPdf] = useState(false);

  const [previewModal, setPreviewModal] = useState(false);
  const [previewData, setPreviewData] = useState(false);

  const [successModal, setSuccessModal] = useState(false);
  const [selectRecipient, setSelRecipient] = useState('');

  const [userData, setUserData] = useState('');

  const [showEsignDp, setShowEsignDp] = useState(false);

  const [inputFields, setInputFields] = useState([]);
  const [confirmPublishModal, setConfirmPublishModal] = useState(false);

  const { getParameter } = useQueryParameters();
  const fileId = getParameter('fileId');
  const createmode = getParameter('createmode');
  const esign = getParameter('esign');
  const [autoSaveTimer, setAutoSaveTimer] = useState(null);
  const [showIsStampRequired, setShowIsStampRequired] = useState(false);
  const [paymentGatewayEnable, setPaymentGatewayEnable] = useState(false);
  const { digitalStampOrderStatus } = useSelector(state => state.dashboard);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    getStoredFiles();
    handleFetchConfigData();
  }, [digitalStampOrderStatus, fileId]);

  useEffect(() => {
    handlePayload();
  }, [previewFile]);

  // to load pdf signatures of ,ultiple pdf files
  useEffect(() => {
    if (selPdf.id && createmode === 'false') {
      setSnackbar(true);
      setSnackbarMsg('Loading please wait');
      dispatch(setPdfloader(true));
      setTimeout(() => {
        setSnackbarMsg('');
        setSnackbar(false);
        getPdfSingFeild(createmode, singedInputFields);
        dispatch(setPdfloader(false));
      }, 2000);
    }
  }, [selPdf]);

  useEffect(() => {
    //check for pdf
    if (selectedFile && selectedFile?.length > 0 && selectedFile[0]?.type === 'pdf' && createmode === 'false') {
      setIsPdf(true);
    }
  }, [attachedfiles]);

  useEffect(() => {
    if (singedInputFields?.length > 0 && createmode === 'false' && isPdf) {
      setTimeout(() => {
        setSignInputFields(singedInputFields);
        getPdfSingFeild(createmode, singedInputFields);
      }, 2200);
    }
    if (singedInputFields?.length > 0 && createmode === 'false' && !isPdf) {
      setTimeout(() => {
        setTemplateSingedFields(singedInputFields);

        getSignFields(createmode, singedInputFields);
      }, 2200);
    }
  }, [singedInputFields, isPdf]);

  useEffect(() => {
    if (recpInput?.length > 0 && createmode === 'false') {
      setTimeout(() => {
        setRecipientInputFields(recpInput);
        fillRecipientsInput(createmode, recpInput);
      }, 2300);
    }
  }, [recpInput]);

  const getStoredFiles = async () => {
    try {
      if (fileId !== 'undefined') {
        const Response = await fetchTemplateById(fileId);
        if (Response.status === 200) {
          dispatch(selecteFileStatus(Response.data));
          setOriginalFiles(Response.data);
        }
      }
    } catch (error) {
      return error;
      // console.log(error, 'error response');
    }
  };

  useEffect(() => {
    if (fileId && originalFiles) {
      const findFile = originalFiles?.templateId === fileId && originalFiles;
      if (findFile) {
        const { templateConfig } = findFile;
        const dropdownFields = templateConfig?.dropdownField || [];
        const inputFields = templateConfig?.fields || [];

        const parsedData = {
          ...findFile,
          templateConfig: {
            dropdownField: dropdownFields,
            fields: inputFields
          }
        };

        setPreviewFile(parsedData);
        if (inputFields?.length > 0) {
          inputFields.forEach(el => {
            setUserData(preValue => ({ ...preValue, [el.id]: el.type === 'checkbox' ? el.isChecked : el.required }));
          });
        }
      }
    }
  }, [fileId, originalFiles]);

  const handlePayload = () => {
    let modifiedTemplateConfig = {};

    if (
      previewFile.templateConfig &&
      typeof previewFile.templateConfig === 'object' &&
      Array.isArray(previewFile.templateConfig.fields)
    ) {
      // Filter fields array when value is not empty
      let filteredFields = previewFile.templateConfig.fields.filter(field => field.value !== '');
      let filteredDropdown = previewFile.templateConfig.dropdownField.filter(field => field.hasOwnProperty('value'));
      let dropdownFieldWithoutOptions = filteredDropdown.map(field => {
        const { options, ...rest } = field;
        return { ...rest, type: 'dropdownFieldOutSide' };
      });

      // Merge filteredFields and dropdownFieldWithoutOptions arrays into fields array
      let newTemplateConfig = {
        ...previewFile.templateConfig,
        fields: [...filteredFields, ...dropdownFieldWithoutOptions]
      };

      // Remove dropdownField property from newTemplateConfig
      delete newTemplateConfig.dropdownField;

      // Change property name from "fields" to "templateInfoConfig"
      newTemplateConfig.templateInfoConfig = newTemplateConfig.fields;
      delete newTemplateConfig.fields;

      // Assign the modified object to the variable
      modifiedTemplateConfig = newTemplateConfig;
      getDataOne(modifiedTemplateConfig);
      getDataTwo(previewFile);
    }
  };

  const handleSave = async shouldexit => {
    if (!isPdf) {
      try {
        setIsLoading(true);
        const response = await handleTemplateSave(
          editor,
          createmode,
          dispatch,
          fileId,
          holdTemplateName,
          borderData,
          marginData,
          editorPageSize,
          stampConfig,
          shouldexit,
          handleExit,
          pageOrientation,
          additionalCharges,
          isAdditionalAmountRequired,
          originalFiles.templateStatus
        );
      } catch (error) {
        showToast('error', error?.message);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleExit = () => {
    //update template data need API for updating template
    dispatch(addAdditionalCharges({ additionalAmount: 0, additionalAmountDescription: '' }));
    dispatch(updateContent(''));
    dispatch(holdTemplateNames(null));
    navigate('/template');
  };

  function formatDate(date) {
    if (date instanceof Date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    } else {
      return date;
    }
  }

  const handleFieldInput = (value, type, selel, name) => {
    if (!value) {
      showToast('warning', 'Please add all the required fields');
      return;
    }
    let allData = { ...previewFile };
    allData.templateConfig.fields = allData.templateConfig.fields.map(el => {
      if (el.id === selel.id) {
        return { ...el, value: value };
      }
      return el;
    });

    const findElement = document.querySelector('#' + selel.id);
    if (findElement) {
      findElement.scrollIntoView({ block: isMobile ? 'nearest' : 'center', behavior: 'smooth', inline: 'nearest' });
      if (type === 'checkbox') {
        findElement.checked = value;
        findElement.setAttribute('checked', value);
      } else {
        findElement.setAttribute('value', value);

        if (type === 'text') {
          const multiplier = value?.length > 14 ? 9.5 : 12;
          findElement.style.width = `${value?.length * multiplier}px`;
        }
        if (type === 'date') {
          // console.log('value', value);
          const formattedDate = formatDate(value);
          // console.log('formattedDate', formattedDate);
          findElement.setAttribute('value', formattedDate);
        }
        // setUserData(preValue => ({ ...preValue, [name]: value }));
      }
    }

    setPreviewFile(allData);
  };

  const handleSignChange = (value, type, selel) => {
    const findElement = document.querySelectorAll('#signinput' + selel.inputId);

    const updateInputFields = inputFields.map(el => (el.inputId === selel.inputId ? { ...el, value: value } : el));

    if (findElement.length > 0) {
      [...findElement].forEach(el => {
        el.setAttribute('value', value);
        el.style.width = `${value.length * 9}px`;
      });
    }

    setInputFields(updateInputFields);
  };

  const handleDropDownChange = (e, selOpt) => {
    const { value } = e.target;
    let allData = { ...previewFile };
    allData.templateConfig.dropdownField = allData.templateConfig.dropdownField.map(el => {
      if (el.id === selOpt.id) {
        return { ...el, value: value };
      }
      return el;
    });

    const findElement = document.querySelector('#' + selOpt.id);

    if (findElement) {
      findElement?.scrollIntoView({ behavior: 'smooth', block: isMobile ? 'nearest' : 'center' });
      findElement.value = value;
      findElement.setAttribute('value', value);
      // setUserData({ ...userData, [selOpt.id]: value });
      // } else if (createmode === 'false') {
      //   findElement.innerHTML = value;
      // }
    }

    setPreviewFile(allData);
  };

  const getInputField = inputField => {
    if (createmode === 'false' && window.location.pathname !== '/templatepreview') {
      const allcontainers = document.querySelectorAll('.pdf-sign');

      [...allcontainers].forEach(el => {
        inputField.forEach(item => {
          const checkElm = document.querySelector('#signinput' + item.inputId);
          if (checkElm) {
            return '';
          }
          const createInputTag = document.createElement('input');
          createInputTag.readOnly = true;
          createInputTag.setAttribute('type', 'text');
          createInputTag.setAttribute('id', 'signinput' + item.inputId);
          createInputTag.setAttribute('name', 'Signature');
          createInputTag.setAttribute('placeholder', 'Signature');
          createInputTag.setAttribute('value', item.value);
          createInputTag.setAttribute('class', 'template-input template-input-selector input-esign');
          el.appendChild(createInputTag);
        });
      });
    }
  };

  const handleSignPdf = () => {
    const inputId = nanoid(5);

    if (inputFields.length > 9) {
      setSnackbar(true);
      setSnackbarMsg('Can only add 10 signatures for now');
      return '';
    }

    setSnackbar(false);
    setSnackbarMsg('');
    const newinputField = [
      ...inputFields,
      {
        type: 'text',
        id: 'signinput' + inputId,
        name: 'Signature',
        placeholder: 'Signaturewtertr',
        inputId,
        value: ''
      }
    ];
    setInputFields(newinputField);
    getInputField(newinputField);
  };

  const handleSignTemplate = () => {
    setShowEsignDp(true);
  };

  const handlePreview = () => {
    const htmlData = mapFields(createmode, true, false, true, true);

    if (htmlData) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlData;
      mapTables(tempDiv);
      setPreviewData({
        templateHtml: tempDiv.innerHTML,
        templateConfig: { marginData: JSON.stringify(marginData), borderData: JSON.stringify(borderData) }
      });
      setPreviewModal(true);
    }
  };

  const handleAnimation = selElm => {
    const item = document.querySelector('#' + selElm.id);
    item.classList.add('selected-elem');
    setTimeout(() => {
      item.classList.remove('selected-elem');
    }, 1000);
  };
  const handlePublishChange = () => {
    setConfirmPublishModal(!confirmPublishModal);
  };

  const handlePublishCloseConfirmModal = () => {
    setConfirmPublishModal(!confirmPublishModal);
    setOriginalFiles({ ...originalFiles, templateStatus: 'Draft' });
  };
  const handlePublishConfirmModal = async () => {
    try {
      setIsLoading(true);
      if (!isPdf) {
        let isupdated = await handleTemplateSave(
          editor,
          createmode,
          dispatch,
          fileId,
          holdTemplateName,
          borderData,
          marginData,
          editorPageSize,
          stampConfig,
          false,
          handleExit,
          pageOrientation,
          additionalCharges,
          isAdditionalAmountRequired,
          'Published'
        );
        if (isupdated) {
          setOriginalFiles({ ...originalFiles, templateStatus: 'Published' });
        }
      }
      setConfirmPublishModal(!confirmPublishModal);
    } catch (error) {
      showToast('error', error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = event => {
    dispatch(setAutoSave(event.target.checked));

    if (event.target.checked && fileId !== undefined) {
      if (autoSaveTimer) {
        clearInterval(autoSaveTimer);
        setAutoSaveTimer(null);
      }

      const timerId = setInterval(() => {
        if (location.pathname === '/edit') {
          handleSave(false);
          setSnackbar(true);
          setSnackbarMsg('File Save Automatically');
          setTimeout(() => {
            setSnackbarMsg('');
            setSnackbar(false);
          }, 2000);
        } else clearInterval(timerId);
      }, 10000);

      setAutoSaveTimer(timerId);
    } else if (autoSaveTimer) {
      clearInterval(autoSaveTimer);
      setAutoSaveTimer(null);
    }
  };

  const handleFetchConfigData = async () => {
    try {
      const response = await GetConfigData();
      // console.log(response);
      if (response?.status === 200) {
        if (response?.config?.showIsStampRequired == true && digitalStampOrderStatus) {
          setShowIsStampRequired(response?.config?.showIsStampRequired);
        }
        if (response?.config?.paymentGatewayEnable) {
          setPaymentGatewayEnable(response?.config?.paymentGatewayEnable);
        }
      }
    } catch (apiError) {
      showToast('error', apiError?.message || 'Oops, Something went wrong, try again later!');
    }
  };

  return (
    <>
      <Box position={'relative '} height={'auto'} minHeight={'100%'} display={'flex'} flexDirection={'column'}>
        {createmode === 'true' && (
          <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
            <span style={{ fontSize: '16px' }}>Auto save</span>
            <Switch checked={autoSave} onChange={handleChange} inputProps={{ 'aria-label': 'controlled' }} />
          </div>
        )}
        <PreviewUploadDocument
          thumbnailContent={previewData}
          openPDF={previewModal}
          setOpenPDF={setPreviewModal}
          thumbFlag={true}
          setThumbFlag={() => ''}
          removeMarginLeftRight
          windowWidth={692}
        />

        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center'
          }}
          open={snackBar}
          autoHideDuration={6000}
          onClose={() => setSnackbar(!snackBar)}
          message={snackBarmsg}
        />
        <SuccessModal
          message='Successful'
          btnText={'Done'}
          showImage
          recipients={storedRecipients.map(el => el.userData)}
          open={successModal}
          onClose={() => setSuccessModal(!successModal)}
        ></SuccessModal>

        <GeneralModal
          open={confirmPublishModal}
          onClose={handlePublishCloseConfirmModal}
          btn2OnClick={handlePublishConfirmModal}
          genText={'Publish Template'}
          genTextClassName={'medium1'}
          btn1Text={'No, keep as Draft'}
          btn1OnClick={handlePublishCloseConfirmModal}
          no2btn={false}
          btn2Text={'Publish'}
        >
          <p className='medium6' style={{ marginTop: '10px' }}>
            Are you sure you want to Publish this Template for eSign workflow?{' '}
          </p>
          <p className='medium6' style={{ marginTop: '10px' }}>
            Once the Template is published it cannot be marked as Draft again!!
          </p>

          <p className='medium6' style={{ marginTop: '10px' }}>
            This template will be available for download once is it published.
          </p>
        </GeneralModal>

        <Box mt={isMobile ? 2 : 0} display={'flex'} flexWrap={'wrap'} gap={1}>
          {!isPdf && (
            <>
              {createmode === 'true' && <div className='semiBold5'>Format</div>}
              <Box
                mt={0}
                mb={4}
                width={'100%'}
                rowGap={1}
                display={createmode === 'true' ? 'flex' : 'none'}
                flexDirection={'column'}
              >
                <Box display={createmode === 'true' ? 'flex' : 'none'} width={'100%'} gap={1}>
                  <div style={{ width: '100%' }} onClick={() => handleSidebarClick('text')}>
                    <CkEeditorfields name={'Text'} isDisable={createmode === 'false'} icon={AlignIcon} width={'100%'} />
                  </div>
                  <div style={{ width: '100%' }} onClick={() => handleSidebarClick('image')}>
                    <CkEeditorfields
                      name={'Image'}
                      isDisable={createmode === 'false'}
                      icon={imageIcon}
                      width={'100%'}
                    />
                  </div>
                </Box>
                <Box display={createmode === 'true' ? 'flex' : 'none'} width={'100%'} gap={1}>
                  <div style={{ width: '100%' }} onClick={() => handleSidebarClick('line')}>
                    <CkEeditorfields isDisable={createmode === 'false'} name={'Line'} icon={LineIcon} width={'100%'} />
                  </div>
                  <div style={{ width: '100%' }} onClick={() => handleSidebarClick('table')}>
                    <CkEeditorfields
                      name={'Tables'}
                      isDisable={createmode === 'false'}
                      icon={TableIcon}
                      width={'100%'}
                    />
                  </div>
                </Box>
                <Box display={createmode === 'true' ? 'flex' : 'none'} width={'100%'} gap={1}>
                  <div style={{ width: '100%' }} onClick={() => handleSidebarClick('pagesetting')}>
                    <CkEeditorfields
                      name={'Page Settings'}
                      isDisable={createmode === 'false'}
                      icon={PageIcon}
                      width={'100%'}
                    />
                  </div>
                </Box>
              </Box>
              <div className={isMobile ? 'semiBold14' : 'semiBold5'}>Fillable Fields</div>
              <Box display={createmode === 'true' ? 'flex' : 'none'} width={'100%'} gap={1} mt={0}>
                <div style={{ width: '100%' }} onClick={() => handleSidebarClick('date')}>
                  <CkEeditorfields isDisable={createmode === 'false'} name={'Date'} icon={dateIcon} width={'100%'} />
                </div>
                <div style={{ width: '100%' }} onClick={() => handleSidebarClick('input')}>
                  <CkEeditorfields name={'Text Fields'} isDisable={createmode === 'false'} icon={icon} width={'100%'} />
                </div>
              </Box>
              <Box display={createmode === 'true' ? 'flex' : 'none'} width={'100%'} gap={1}>
                <div style={{ width: '100%' }} onClick={() => handleSidebarClick('checkbox')}>
                  <CkEeditorfields
                    name={'Checkbox'}
                    isDisable={createmode === 'false'}
                    icon={CheckboxIcon}
                    width={'100%'}
                  />
                </div>
                <div style={{ width: '100%' }} onClick={() => handleSidebarClick('dropdown')}>
                  <CkEeditorfields
                    isDisable={createmode === 'false'}
                    name={'Dropdown'}
                    icon={DropdownIcon}
                    width={'100%'}
                  />
                </div>
              </Box>
              <Box display={createmode === 'true' ? 'flex' : 'none'} width={'100%'} gap={1}>
                <div
                  style={{ width: '100%' }}
                  onClick={() => {
                    handleSidebarClick('addrecipient');
                  }}
                >
                  <CkEeditorfields
                    isDisable={(createmode === 'false' && !isPdf) || disableAddRecipient}
                    name={'Recipient'}
                    width='100%'
                    icon={TagUserIcon}
                  />
                </div>
                <div style={{ width: '100%' }}>
                  <div
                    style={{ width: '100%' }}
                    onClick={() => {
                      isPdf ? handleSignPdf() : handleSidebarClick('esign');
                    }}
                  >
                    <CkEeditorfields
                      isDisable={createmode === 'false' && !isPdf}
                      name={'Sign'}
                      width='100%'
                      icon={fieldIcon}
                    />
                  </div>
                </div>
              </Box>
              <Box display={createmode === 'true' ? 'flex' : 'none'} width={'100%'} gap={1}>
                {showIsStampRequired && (
                  <div style={{ width: '100%' }} onClick={() => handleSidebarClick('addStamp')}>
                    <CkEeditorfields
                      name={'Stamp D.'}
                      isDisable={createmode === 'false'}
                      icon={StampIcon}
                      width={'100%'}
                    />
                  </div>
                )}
                {!paymentGatewayEnable ? (
                  <div style={{ width: '100%' }}>
                    <CkEeditorfields
                      name={'Add. Charges'}
                      isDisable={true}
                      icon={StampIcon}
                      width={'100%'}
                      title={'Please Enable and Configure the Payment Gateway from Global Settings'}
                    />
                  </div>
                ) : (
                  <div style={{ width: '100%' }} onClick={() => handleSidebarClick('addCharges')}>
                    <CkEeditorfields
                      name={'Add. Charges'}
                      isDisable={createmode === 'false'}
                      icon={StampIcon}
                      width={'100%'}
                    />
                  </div>
                )}
              </Box>
            </>
          )}

          {createmode === 'false' && (
            <div
              style={{ width: '100%' }}
              onClick={() => {
                handleSignTemplate();
              }}
            >
              <CkEeditorfields
                isDisable={createmode === 'false' && !isPdf}
                name={'Sign'}
                width='100%'
                icon={fieldIcon}
              />
            </div>
          )}
        </Box>

        <Box mt={1} width={'100%'} height={'100%'}>
          {esign === 'true' && createmode === 'false' && !isPdf && (
            <Box
              sx={{
                display: isMobile
                  ? 'none'
                  : previewFile?.templateConfig?.fields.find(el => el.isrecipient === 'recipient')
                    ? 'block'
                    : 'none'
              }}
            >
              <Box mb={2}>
                <div className='medium5'>Choose Recipient</div>
              </Box>
              <Box
                mt={0}
                sx={{
                  maxHeight: 250,
                  overflowY: 'auto',
                  padding: '10px 0',
                  ...(scrollstyleCss || {})
                }}
              >
                <Box>
                  <CkRecipientDropDown
                    selectRecipient={selectRecipient}
                    setSelRecipient={setSelRecipient}
                    recipients={storedRecipients}
                    inputFields={recipientInputFields}
                    setInputFields={setRecipientInputFields}
                    isPdf={isPdf}
                    originalFile={previewFile}
                    setOriginalFile={setPreviewFile}
                  />
                </Box>
              </Box>
            </Box>
          )}

          <div>
            <Box mt={2} height={'100%'}>
              {inputFields.length > 0 && (
                <div
                  className='inputsing-wrapper'
                  style={{
                    height: inputFields.length > 2 ? 400 : 'auto'
                  }}
                >
                  {inputFields.map(elem => (
                    <Box mt={2} key={elem.inputId}>
                      <TextField
                        text={elem.name}
                        placeholder={elem.placeholder ? elem.placeholder : 'placeholder'}
                        type={elem.type}
                        value={elem.value}
                        handleInput={value => handleSignChange(value, elem.type, elem, elem.value)}
                        name={'signature'}
                        disabled={snackBar}
                        maxLength={30}
                        error={''}
                        removeImageLeftBorder
                        labelClassName={'medium7'}
                      />
                    </Box>
                  ))}
                </div>
              )}

              {storedRecipients.length > 0 && createmode === 'false' && (
                <Box
                  sx={{
                    display: !isPdf
                      ? previewFile?.templateConfig?.fields.find(el => el.isrecipient === 'esign')
                        ? 'block'
                        : 'none'
                      : 'block',
                    maxHeight: 220,
                    overflowY: 'auto',
                    ...(scrollstyleCss || {})
                  }}
                >
                  <CKeditorSignDropDown
                    recipients={storedRecipients}
                    inputFields={signinputFields}
                    setInputFields={setSignInputFields}
                    isPdf={isPdf}
                    templateSign={templateSingedFields}
                    setTemplateSign={setTemplateSingedFields}
                    originalFile={previewFile}
                    setOriginalFile={setPreviewFile}
                    documentID={documentID}
                  />
                </Box>
              )}
            </Box>
          </div>
          {createmode === 'false' &&
            (previewFile?.templateConfig?.fields?.length > 0 ||
              previewFile?.templateConfig?.dropdownField?.length > 0) && (
              <div className='template-textdfields-wrapper'>
                {previewFile?.templateConfig?.fields?.map((el, i) => (
                  <span key={el.id}>
                    {el.type === 'checkbox' && (
                      <div
                        key={el.id}
                        className='medium5'
                        style={{
                          display: 'flex',
                          gap: '8px',
                          alignItems: 'center'
                        }}
                      >
                        <input
                          type='checkbox'
                          name={el.fieldname}
                          value={el.value}
                          checked={document.querySelector('#' + el.id)?.checked}
                          onChange={e => handleFieldInput(e.target.checked, el.type, el, el.id)}
                        />
                        {el.value}
                      </div>
                    )}

                    {el.type === 'date' && (
                      <input
                        className='template-ui_select'
                        type='date'
                        name={el.name}
                        id={el.id}
                        value={el.value}
                        // value={document.querySelector('#' + el.id)?.value}
                        min={el.min}
                        max={el.max}
                        required={el.required}
                        onChange={e => handleFieldInput(e.target.value, el.type, el, el.id)}
                      />
                    )}
                    {el.type === 'text' && el.isrecipient !== 'recipient' && el.isrecipient !== 'esign' && (
                      <TextField
                        handleClick={() => handleAnimation(el)}
                        key={el.id}
                        text={el.fieldname}
                        placeholder={el.placeholder ? el.placeholder : 'placeholder'}
                        type={el.type}
                        handleInput={value => handleFieldInput(value, el.type, el, el.id)}
                        name={el.fieldname}
                        maxLength={30}
                        value={document.querySelector('#' + el.id)?.value}
                        required={el.required}
                        error={''}
                        removeImageLeftBorder
                        labelClassName={'medium7'}
                      />
                    )}
                  </span>
                ))}

                {previewFile?.templateConfig?.dropdownField?.map((el, index) => (
                  <select
                    onClick={() => handleAnimation(el)}
                    className='template-ui_select'
                    name={el.fieldname}
                    id={el.id}
                    value={el.value}
                    onChange={e => handleDropDownChange(e, el, el.fieldname)}
                    // value={document.querySelector('#' + el.id)?.value}
                    // onChange={e => handleDropDownChange(e, el)}
                    key={el.id}
                  >
                    {el?.options?.map(opt => (
                      <option key={opt.name} value={opt.value}>
                        {opt.value}
                      </option>
                    ))}
                  </select>
                ))}
              </div>
            )}
        </Box>

        <Box
          pt={2}
          pb={0.5}
          justifySelf={'flex-end'}
          mt={'auto'}
          display={'flex'}
          flexDirection={'column'}
          rowGap={2}
          marginBottom={3}
        >
          {createmode === 'true' && (
            <>
              <PrimaryButton
                value={'Save template'}
                id='savetemplateOnly'
                backgroundColor={'#B7D423'}
                width={'100%'}
                onClick={() => handleSave(false)}
                btnClass='template-save_btn'
                textcolor={'#21241E'}
                customStyle={{
                  border: '1px solid #b7d423',
                  fontFamily: 'Gilroy-SemiBold'
                }}
              />
              <PrimaryButton
                value={'Preview'}
                backgroundColor={'#B7D423'}
                width={'100%'}
                onClick={handlePreview}
                btnClass='template-save_btn'
                textcolor={'#21241E'}
                customStyle={{
                  border: '1px solid #b7d423',
                  fontFamily: 'Gilroy-SemiBold'
                }}
              />
              <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                <PrimaryButton
                  value={originalFiles.templateStatus == 'Published' ? 'Published' : 'Publish'}
                  backgroundColor={'#B7D423'}
                  width={'100%'}
                  onClick={() => {
                    handlePublishChange();
                  }}
                  marginTop={'0px'}
                  btnClass='template-save_btn'
                  textcolor={'#21241E'}
                  customStyle={{
                    border: '1px solid #b7d423',
                    fontFamily: 'Gilroy-SemiBold'
                  }}
                  disabledStyle={{
                    backgroundColor: '#b6d423',
                    opacity: '0.7',
                    color: 'black'
                  }}
                  disabled={originalFiles.templateStatus == 'Published'}
                />
              </div>
              <PrimaryButton
                value={'Save template and Exit'}
                backgroundColor={'#B7D423'}
                width={'100%'}
                onClick={() => handleSave(true)}
                marginTop={'0px'}
                btnClass='template-save_btn'
                textcolor={'#21241E'}
                customStyle={{
                  border: '1px solid #b7d423',
                  fontFamily: 'Gilroy-SemiBold'
                }}
              />
            </>
          )}
        </Box>
      </Box>
      {isLoading && <Loading open={isLoading} onClose={() => setIsLoading(false)} />}
    </>
  );
}

export default CKeditorAddComp;
